var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){return _vm.goToMasterPlan(_vm.location)}}},[_c('button',{staticClass:"btn btn-outline-dark btn-sm",staticStyle:{"cursor":"pointer"}},[_vm._v(" "+_vm._s(_vm.location.type)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }